<div class="main-panel">
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 mt-3">
        <div class="row">
          <div class="col-md-8">
            <ul class="nav nav-tabs iris-gst-display-flex" role="tablist">
              <li class="nav-item show active">
                <a class="nav-link " id="ewb-tab" data-toggle="tab" href="#ewb" role="tab" aria-controls="ewb"
                  aria-selected="true" (click)="clearData()">Subscription</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content pl0 pr0">
          <div class="tab-pane fade show active" id="ewb" role="tabpanel" aria-labelledby="ewb-tab">
            <div class="row">
              <div class="col-xl-12 grid-margin stretch-card">
                <div class="card">
                  <div class="row">
                    <div class="col-md-12 stretch-card">
                      <div class="card-body">
                        <form class="forms-sample" [formGroup]="subcribeForm" autocomplete="off">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group row pb-1">
                                <div class="col-sm-12">
                                  <label  class="col-sm-3 col-form-label">PAN Number</label>
                                  <input type="text" class="form-control" id="Input-field"
                                    placeholder="Enter PAN number" formControlName="pan"
                                    [ngClass]="{ 'errorBorder': isSubmitted && ef.pan.errors }">
                                  <div *ngIf="isSubmitted && ef.pan.errors">
                                    <span class="text-danger" *ngIf="ef.pan.errors.required"> PAN
                                      Required
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group mt52">
                                <span class="form-check mt-3">
                                  <label class="form-check-label inlineDisplay">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="sapphire" (change)="setProduct()">
                                    <i class="input-helper"></i></label>Sapphire</span>
                              </div>
                            </div>
                            <!-- <div class="col-md-3">
                              <div class="form-group mt52">
                                <span class="form-check mt-3">
                                  <label class="form-check-label inlineDisplay">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="onyx" (change)="setProduct()">
                                    <i class="input-helper"></i></label>Onyx</span>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mt52">
                                <span class="form-check mt-3">
                                  <label class="form-check-label inlineDisplay">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="topaz" (change)="setProduct()">
                                    <i class="input-helper"></i></label>Topaz</span>
                              </div>
                            </div> -->
                          </div>
                          <div class="row" *ngIf="sapphire">
                            <div class="col-md-4">
                              <div class="form-group row pb-1">
                                <div class="col-sm-12">
                                  <label class="col-form-label">Select Tenant </label>
                                  <select class="form-control" [(ngModel)]="sapphireTenantDoamin">
                                      <option [value]="">-- Select Tenant --</option>
                                      <ng-container *ngFor="let obj of tenantList">
                                          <option [value]="obj.key">{{obj.value}}</option>
                                      </ng-container>
                                  </select>
                              </div>
                              </div>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-md-4 pt-xl-5">
                              <button class="btn btn-outline-primary mr-1" id="clickSearch"
                                (click)="search()">Submit</button>
                              <button class="btn btn-outline-primary mr-1" (click)="clearData()">Clear</button>
                            </div>
                          </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- main-panel ends -->
</div>
